
import { Link } from "react-router-dom";
import { useT } from "../i18n";
import LangToggle from "./LangToggle";
import ServiceLauncher from "./ServiceLauncher";
import { HISTORY_URL } from "./externalApps";
import ServiceMenu from "./ServiceMenu";

const FullpageHeader = ({ userInfo , logout}) => {
    const t = useT();
    
    return(
        <div className="header_bg">
            <div className="width_con">
                <header>
                    <input className="burger-check" type="checkbox" id="burger-check" />
                    <label className="burger-icon" htmlFor="burger-check">
                    <span className="burger-sticks"></span>
                    </label>
                    <div className="menu">
                        <ul className="menu_contents">
                            {userInfo === null ? 
                            <li><Link to='/login' state={{ returnUrl : window.location.href}}>{t('Log In')}</Link></li> :
                            <>                 
                            <li><a onClick={logout} href="#">{t('Log Out')}</a></li>
                            </>
                            }
                            <li className="about"><Link to='/about'>{t('About')}</Link></li>
                            <ServiceMenu />
                            {/* <li className="people"><Link to=''>People</Link></li> */}
                            {/* <li><a href="/project">Project</a></li> */}
                            <li className="people"><Link to='/people'>{t('People')}</Link></li>
                            <li className="news">
                                <Link to="/news">{t('News')}</Link>
                            </li>
                            <li className="history">
                                <a href={HISTORY_URL}>{t('History')}</a>
                            </li>
                            {userInfo !== null && (
                                <li className="my_page">
                                    <Link to="/mypage">{t('My page')}</Link>
                                </li>
                            )}
                            <li className="lang">
                                <LangToggle />
                            </li>
                        </ul>
                    </div>
                <ServiceLauncher />
                </header>                
            </div>
        </div>
    )
}

export default FullpageHeader;